export default __webpack_public_path__ + "c49157db7f84c55a383f4f7b5063b926.png";